const ProductsData=[
    {
        id:1,
        imgURL:"./imges/template6.jpg",
        name:"Product1",
        price:"20",
        description:"Some quick example text to build on the card title and make up the bulk of the card's content."
    },
    {
        id:2,
        imgURL:"./imges/template8.jpg",
        name:"Product2",
        price:"18",
        description:"Some quick example text to build on the card title and make up the bulk of the card's content."
    },
    {
        id:3,
        imgURL:"./imges/template7.jpg",
        name:"Product3",
        price:"16",
        description:"Some quick example text to build on the card title and make up the bulk of the card's content."
    },
    {
        id:4,
        imgURL:"./imges/template7.jpg",
        name:"Product4",
        price:"16",
        description:"Some quick example text to build on the card title and make up the bulk of the card's content."
    },
    {
        id:5,
        imgURL:"./imges/template6.jpg",
        name:"Product5",
        price:"20",
        description:"Some quick example text to build on the card title and make up the bulk of the card's content."
    },
    {
        id:6,
        imgURL:"./imges/template8.jpg",
        name:"Product6",
        price:"18",
        description:"Some quick example text to build on the card title and make up the bulk of the card's content."
    }
];

export default ProductsData;